import Paginator from "../../screens/group/Paginator.js";
export default class HistoryPaginator extends Paginator {
  get pages() {
    return 10000;
  }
  get count() {
    return Number.MAX_SAFE_INTEGER;
  }
  get hasNextPage() {
    const {
      items
    } = this.data;
    return items.length === this.perPage;
  }
  get pageItems() {
    const {
      items
    } = this.data;
    return items;
  }
  get loading() {
    return this.data.loading;
  }
  setPerPage(perPage) {
    const {
      onPageChange
    } = this.options;
    if (typeof perPage === 'number' && perPage > 0 && onPageChange) {
      const page = 0;
      onPageChange({
        perPage,
        page
      });
    }
  }
}

// export default class HistoryPaginator {
//   constructor( options ) {
//     this.data = {}
//     this.options = options
//     this.pageCache = new ValuesCache()
//   }

//   setData( data ) {
//     this.data = data
//   }

//   get loading() {
//     return this.data.loading
//   }

//   get perPage() {
//     return this.data.perPage > 0 ? this.data.perPage : 0
//   }

//   get page() {
//     return this.data.page > 0 ? this.data.page : 0
//   }

//   get startIndex() {
//     const page = this.page
//     const perPage = this.perPage

//     return page * perPage
//   }

//   get endIndex() {
//     const page = this.page
//     const perPage = this.perPage
//     return Math.min( ( page + 1 ) * perPage - 1, this.count - 1 )
//   }

//   get displayPage() {
//     return this.page + 1
//   }

//   get displayStartIndex() {
//     return this.startIndex + 1
//   }

//   get displayEndIndex( ) {
//     return this.endIndex + 1
//   }

//   get pageItems() {
//     const { items, perPage, loading } = this.data
//     const page = this.page

//     if ( loading ) {
//       return []
//     }

//     return this.pageCache.calc( page, ( items ) => {
//       const start = perPage * page
//       return items.slice( start, start + perPage )
//     }, items, perPage ) 
//   }

//   setPerPage( perPage ) {
//     const { onPageChange } = this.options 
//     if ( typeof perPage === 'number' && perPage > 0 && onPageChange ) {
//       onPageChange( { perPage, page : 0 } )
//     }
//   }

//   setPage( page ) {
//     const { onPageChange } = this.options 
//     if ( typeof page === 'number' && page >= 0 && onPageChange && page !== this.page ) {
//       onPageChange( { perPage : this.perPage, page } )
//     }
//   }

//   setPreviousPage() {
//     const page = this.page

//     this.setPage( page - 1 )
//   }

//   setNextPage() {
//     const page = this.page

//     this.setPage( page + 1 )
//   }
// }